/**
 * 商品詳細のお気に入りボタン（Swym）安定化
 *
 * Prestige はバリエーション変更時に <buy-buttons> を差し替える。
 * Swym V1 はその中にボタンを挿すため一度消える。
 * 同時に Swym V2（advanced-pdp-button.js）が再初期化し、
 * window.swymWishlistV2Config が無いと
 * 「Configure button HTML in theme editor」で上書きする。
 *
 * このスクリプトは
 * 1. セクション内の JSON 設定を V2 に渡す
 * 2. V2 が V1 ボタンをプレースホルダで潰さないようにする
 * 3. カートボタンの外に退避スロットを作り、差し替え後もボタンを残す
 */
(function () {
  var ERROR_RE = /Configure button HTML in theme editor/;
  var SLOT_ID = 'brt-swym-pdp-slot';
  var CONFIG_ID = 'brt-swym-pdp-config';

  function readConfig() {
    var node = document.getElementById(CONFIG_ID);
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function applyConfig() {
    var config = readConfig();
    if (!config) return null;

    window.swymWishlistV2Config = {
      buttonPosition: config.buttonPosition || 'default',
      customSelector: config.customSelector || '',
      beforeHtml: config.beforeHtml || '',
      afterHtml: config.afterHtml || '',
      hasCustomHtml: !!config.hasCustomHtml
    };

    if (config.customCss && !document.getElementById('brt-swym-pdp-button-css')) {
      var style = document.createElement('style');
      style.id = 'brt-swym-pdp-button-css';
      style.textContent = config.customCss;
      document.head.appendChild(style);
    }

    return window.swymWishlistV2Config;
  }

  function getSlot() {
    return document.getElementById(SLOT_ID);
  }

  function ensureSlot() {
    var existing = getSlot();
    if (existing) return existing;

    var buyButtonsBlock = document.querySelector(
      '.shopify-section--main-product [data-block-type="buy-buttons"]'
    );
    if (!buyButtonsBlock) return null;

    var slot = document.createElement('div');
    slot.id = SLOT_ID;
    slot.className = 'brt-swym-pdp-slot';
    slot.hidden = true;
    buyButtonsBlock.appendChild(slot);
    return slot;
  }

  function getV1Container() {
    return document.getElementById('swym-atw-button-container');
  }

  function parkButton() {
    var slot = ensureSlot();
    var container = getV1Container();
    if (!slot || !container) return;

    if (!slot.contains(container)) {
      slot.appendChild(container);
    }
    slot.hidden = slot.childElementCount === 0;
  }

  function isBroken(node) {
    return !!(node && ERROR_RE.test(node.textContent || ''));
  }

  function restoreBrokenButton() {
    var container = getV1Container();
    if (!isBroken(container)) return;

    container.innerHTML = '';
    if (window.WishlistPlusPDPButtonAPI && window._swat) {
      window.WishlistPlusPDPButtonAPI.initializePDPButton(window._swat, false);
    }
    parkButton();
  }

  function patchV2() {
    var api = window.SwymWishlistPDPButtonAPI;
    if (!api || api._brtPatched) return !!(api && api._brtPatched);

    var original = api.attachEventListenersToButton;
    if (typeof original !== 'function') return false;

    api.attachEventListenersToButton = function () {
      var content = document.querySelector('#' + SLOT_ID + ' .swym-button-content, .swym-button-content');
      var config = window.swymWishlistV2Config;
      if (content && config && config.hasCustomHtml && config.beforeHtml) {
        return original.apply(this, arguments);
      }
      parkButton();
    };
    api._brtPatched = true;
    return true;
  }

  function onVariantSettled() {
    applyConfig();
    patchV2();
    parkButton();
    restoreBrokenButton();
  }

  applyConfig();

  var observer = new MutationObserver(function () {
    patchV2();
    parkButton();
    restoreBrokenButton();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('variant:change', function () {
    setTimeout(onVariantSettled, 50);
    setTimeout(onVariantSettled, 400);
  });
  document.addEventListener(
    'product:rerender',
    function () {
      setTimeout(onVariantSettled, 50);
      setTimeout(onVariantSettled, 400);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onVariantSettled);
  } else {
    onVariantSettled();
  }
})();
